import React, { useEffect, useState } from "react";
import { config } from "../../App";
import axios from "axios";

const QuickLinks = () => {

  const empId = sessionStorage.getItem("EmployeeID");
  const token = sessionStorage.getItem("token");
  const [quickLinksData, setQuickLinksData] = useState([]);

  const getQuickLinksData = async () => {
    try {
      const response = await axios.get(
        `${config.endpoint}/Home/getquicklinks?employeeId=${empId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      //console.log("response", response)
      if (response.data.status === true) {
        setQuickLinksData(response.data.Data);
      } else {
        setQuickLinksData([]);
      }

    } catch (error) {
      console.error("failed:", error);
    }
  }

  const handleLinkClick = async (e, item) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `${config.endpoint}/Home/trackquicklink?employeeId=${empId}&linkId=${item.LinkID}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data.status === true) {
        window.open(item.LinkURL, "_blank");
      }

    } catch (error) {
      console.error("API failed:", error);
      //window.open(item.LinkURL, "_blank");
    }
  };

  useEffect(() => {
    getQuickLinksData();
  }, [])

  // console.log("quickLinksData", quickLinksData);

  return (
    <div className="quick-links-card">
      <h3>Quick Links</h3>
      <div className="custom_scrollbar">
      {quickLinksData?.map((item, index) => (
        <a
          key={index}
          href={item.LinkURL}
          onClick={(e) => handleLinkClick(e, item)}
          className="quick-link"
        >
          <span className="fa fa-link me-3"></span> {item.LinkName}
        </a>
      ))}
      </div>
    </div>

  );
};

export default QuickLinks;